import React from 'react';
import Button from '@material-ui/core/Button';
import './ManagerNewAccount.styl';

export default class ManagerNewAccount extends React.PureComponent {
  render() {
    return (
      <div className="manager-new-account">
        <div className="text-content">
          <h3>Welcome to Your Coach Dashboard!</h3>
          <p>
            We’re excited for you to get started. It looks like you’re new to the platform, so
            there’s nothing to show at the moment. When the dashboard does begin populating, you’ll
            see analytics on rep activity, conversation quality, your sales coaching activity, and
            its impact on rep performance.
          </p>
          <p>While you wait, why not school up on getting the most from Coach?</p>
          <p>
            Check out our Help Center to learn more about what’s included in your dashboard, how to
            set up a Smart Alert, and how to quickly coach a call. You can also check out exclusive
            customer webinars where you’ll hear how your peers at other companies are using the
            platform.
          </p>
          <a
            href="https://support.mediafly.com/hc/en-us/sections/14407549154715-Coach-Dashboards"
            target="_blank"
            rel="noreferrer">
            <Button variant="contained" color="primary" className="ev-button">
              Check it Out
            </Button>
          </a>
        </div>
      </div>
    );
  }
}
